import React from 'react'
import cx from 'clsx'

// Components
import { ShareIcon } from '~2024/components/ShareIcon'
import {
  FacebookIcon,
  TwitterIcon,
  PinterestIcon,
  WhatsappIcon,
} from '~2024/components/Icons'

// Styles
import useStyles from './Social.style'

const socialSites = [
  {
    icon: FacebookIcon,
    id: 'facebook',
    title: 'Facebook',
  },
  {
    icon: TwitterIcon,
    id: 'twitter',
    title: 'Twitter',
  },
  {
    icon: PinterestIcon,
    id: 'pinterest',
    title: 'Pinterest',
  },
  {
    icon: WhatsappIcon,
    id: 'whatsapp',
    title: 'WhatsApp',
  },
]

const Social = ({
  url,
  title,
  filterYear,
  detailFandomRank,
  detailFandomTitle,
  detailFilterTitle,
  twitterHandle,
}) => {
  const classes = useStyles()

  return (
    <>
      {socialSites.map((socialSite, index) => (
        <li
          className={cx(classes.siteSharingItem, `icon-${socialSite.id}`)}
          key={`share-icon--${index}`}
        >
          <ShareIcon
            height={28}
            icon={socialSite.icon}
            id={socialSite.id}
            socialTitle={socialSite.title}
            title={title}
            url={url}
            width={28}
            filterYear={filterYear}
            detailFandomRank={detailFandomRank}
            detailFandomTitle={detailFandomTitle}
            detailFilterTitle={detailFilterTitle}
            twitterHandle={twitterHandle}
          />
        </li>
      ))}
    </>
  )
}

export default Social
